// extracted by mini-css-extract-plugin
export default {"spanAll":"WBLiXvy5wZXgTI9vmViw"};